import React, {Component} from 'react';
import AudioPlayer from '../../components/AudioPlayer';
import strings from '../../strings';
import ReadyButton from '../../components/ReadyButton';
import introAfter from '../../assets/sounds/de/intros/SM_Intro-AFTER-trial.mp3';

class PauseAfterTrial extends Component {
	constructor(props) {
		super(props);
		this.audio = introAfter;
	}
	render() {
		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.sm_intro_after_trial_1}
				</p>
				<p>{strings.sm_intro_after_trial_2}</p>
				<ReadyButton
					onReadyChange={this.props.setReady}
					isAdultTest={true}
				/>
			</>
		);
	}
}

export default PauseAfterTrial;
